const benchmarkedsReducer = (state = [], action) => {
    switch (action.type) {
      case "SET_BENCHMARKEDS":
        return action.payload;
      default:
        return state;
    }
  }
  export default benchmarkedsReducer;